<template>
    <b-modal
        id="modal-aggregate-moderation-product-edit"
        ref="modal"
        :title="$t('editProposal')"
        centered
        footer-class="justify-content-start"
        no-close-on-esc
        no-close-on-backdrop
        ok-only
        cancel-variant="light"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
        :ok-title="$t('save')"
        :ok-disabled="requestCatalogMapping.getLoading()"
        @hidden="handleHidden()"
        @ok="handleOk"
        @show="initForm()"
    >
        <b-overlay :show="requestCatalogMapping.getLoading()" class="h-100">
            <form v-if="suggestion" @submit.prevent>
                <b-form-group label-cols="3" :label="$t('name')" :description="`${$t('suggestion')}: ${suggestion.name || ''}`">
                    <b-form-input v-model="form.name" />
                </b-form-group>
                <b-form-group label-cols="3" :label="$t('author')" :description="`${$t('suggestion')}: ${suggestion.author || ''}`">
                    <b-form-input v-model="form.author" />
                </b-form-group>
                <b-form-group label-cols="3" :label="$t('brand')" :description="`${$t('suggestion')}: ${suggestion.brand || ''}`">
                    <b-form-input v-model="form.brand" />
                </b-form-group>
                <b-form-group label-cols="3" :label="$t('variants')">
                    <b-form-checkbox-group v-model="form.variants" :options="suggestion.variants.map(item => ({ value: item, text: `${$t('ean')}: ${item.ean}` }))" class="h-100 d-flex align-items-center" />
                </b-form-group>
            </form>
        </b-overlay>
    </b-modal>
</template>



<script>
    import cloneDeep from 'lodash/cloneDeep';

    export default {
        name: 'ModalEdit',
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestCatalogMapping: this.$req('product/catalogMapping'),
                form: {},
            };
        },
        computed: {
            suggestion() {
                return this.parentComponent.suggestion;
            },
        },
        methods: {
            initForm() {
                this.form = cloneDeep(this.suggestion);
            },
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault();
                this.requestCatalogMapping
                    .post({ urlParams: { id: this.parentComponent.id }, requestParams: this.form })
                    .then(data => {
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                        this.$refs.modal.hide();
                        this.$router.push(this.parentComponent.parentRoute);
                    })
                    .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
            },
            handleHidden() {
                this.form = {};
            },
        },
    };
</script>
